import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';
import { IResponse } from '@shared/models/base/http-response.model';
import { GeneralAppVariables } from '@shared/models/general-app-variables.model';

@Injectable({
  providedIn: 'root',
})
export class GeneralAppVariablesService {
  http = inject(HttpClient);

  // getVariables(): Observable<IResponse<GeneralAppVariables>> {
  //   return this.http.get<IResponse<GeneralAppVariables>>(new URL('/Misc/GetVariables', environment.apiUrl).href);
  // }
}
